const CLIENT_SECRET_MARKER = "_secret_";

/**
 * `pi_XXX_secret_YYY` -> `pi_XXX`. The part after `_secret_` is a bearer credential that can
 * read the payment intent's metadata, so only the id may be stored, submitted or reported.
 * Anything else is returned unchanged.
 */
export const paymentIntentId = (value?: string | null): string | undefined => {
  if (!value) {
    return undefined;
  }

  const markerIndex = value.indexOf(CLIENT_SECRET_MARKER);
  if (markerIndex === -1) {
    return value;
  }

  return value.slice(0, markerIndex);
};
